import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "../constant/path";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";

const Main = ({ scrollToContact }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    requirements: "customised",
    event_type: "Other",
    location: "",
    customLocation: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [captchaValue, setCaptchaValue] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleLocationChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      location: value,
      customLocation: "",
    }));
    if (errors.location) setErrors((prev) => ({ ...prev, location: "" }));
  };

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
    if (errors.captcha) setErrors((prev) => ({ ...prev, captcha: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "First name required";
    if (!formData.lastName.trim()) newErrors.lastName = "Last name required";
    if (!formData.email.trim()) newErrors.email = "Email required";
    if (!formData.phone.trim()) newErrors.phone = "Phone required";
    if (!formData.location.trim()) newErrors.location = "Location required";
    if (formData.location === "Other" && !formData.customLocation.trim())
      newErrors.customLocation = "Enter custom location";
    if (!captchaValue) newErrors.captcha = "Complete CAPTCHA";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setErrorMessage("");
    setSubmitted(false);

    try {
      const formattedFormData = {
        ...formData,
        full_name: `${formData.firstName} ${formData.lastName}`.trim(),
        captcha: captchaValue,
        location:
          formData.location === "Other"
            ? formData.customLocation
            : formData.location,
      };
      delete formattedFormData.firstName;
      delete formattedFormData.lastName;
      delete formattedFormData.customLocation;

      const response = await axios.post(
        `${API_BASE_URL}api/contact/`,
        formattedFormData
      );

      if (response?.data?.success) {
        setSubmitted(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          requirements: "customised",
          event_type: "Other",
          location: "",
          customLocation: "",
        });
        setCaptchaValue(null);
      } else {
        setErrorMessage("Failed to send message. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const destinations = [
    {
      name: "Bali",
      image: "./bali.jpg",
    },
    {
      name: "Georgia",
      image: "./georgia.jpg",
    },
    {
      name: "Singapore",
      image: "./singapore.jpg",
    },
    {
      name: "Malaysia",
      image: "./malaysia.jpg",
    },
  ];

  const holidayPackages = [
    {
      title: "Luxury Family Trips",
      description:
        "Stress-free itineraries, kid-friendly stays, and enriching experiences everyone will love.",
      image: "/photo-1507525428034-b723cf961d3e.avif",
      bg: "bg-green-100",
    },
    {
      title: "Honeymoon / Luxury Couple Packages",
      description:
        "Crafted with romance at the center; think private villas in Bali, wine trails in Georgia, or sunset cruises in Singapore.",
      image: "/photo-1507525428034-b723cf961d3e.avif",
      bg: "bg-blue-100",
    },
    {
      title: "Luxury Group Packages",
      description:
        "Exclusive experiences for celebrations or incentive trips, with premium stays and curated activities.",
      image: "/photo-1501785888041-af3ef285b470.avif",
      bg: "bg-green-100",
    },
  ];

  return (
    <div className="font-sans text-gray-800">
      {/* Hero Section */}
      <section className="bg-white py-12 px-6 md:px-16">
        <div className="grid md:grid-cols-2 gap-8 items-center">
          {/* Left */}
          <div>
            {/* <img
                            src="/20250906_1248_Luxury Global Escapes_simple_compose_01k4ey4s6qexwrgy3py0r4bg5a.png"
                            alt="Hero"
                            className="rounded-lg shadow-md w-200 h-full mb-6"
                            style={{ maxWidth: '676px', maxHeight: '676px' }}
                        /> */}
            <h2 className="text-3xl md:text-4xl font-bold leading-snug mb-4">
              Your Gateway to <br />
              <span className="text-blue-700">
                Luxury International Holidays
              </span>
            </h2>
            <h3 className="text-lg font-semibold text-blue-900 mb-3">
              9+ Years of Travel Excellence: Now for You
            </h3>
            <p className="text-gray-600 leading-relaxed">
              For almost a decade, we’ve been curating seamless journeys for
              leading corporates across the globe. Now, we’re bringing the same
              precision, care, and luxury holiday experiences directly to you.
              Whether it’s a family vacation or the perfect honeymoon escape, we
              design every trip as if it were our own.
            </p>
          </div>

          {/* Right */}
          {/* <div className="flex justify-center md:justify-end">
            <img
              src="/photo-1507525428034-b723cf961d3e.avif"
              alt="Traveler"
              className="rounded-lg shadow-lg w-72 md:w-80 border-4 border-white"
            />
          </div> */}
          <div className="flex justify-center md:justify-end">
            <div
              style={{
                background: "#fff",
                padding: "20px",
                borderRadius: "12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                width: "100%",
                maxWidth: "400px",
                alignSelf: "right",
              }}
            >
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "600",
                  marginBottom: "15px",
                }}
              >
                Get in Touch
              </h3>

              {submitted && (
                <p style={{ color: "green", marginBottom: "10px" }}>
                  ✅ Thank you! Our team will contact you shortly.
                </p>
              )}
              {errorMessage && (
                <p style={{ color: "red", marginBottom: "10px" }}>
                  {errorMessage}
                </p>
              )}

              <form
                onSubmit={handleSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                {errors.firstName && (
                  <span style={{ color: "red" }}>{errors.firstName}</span>
                )}

                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                {errors.lastName && (
                  <span style={{ color: "red" }}>{errors.lastName}</span>
                )}

                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                {errors.email && (
                  <span style={{ color: "red" }}>{errors.email}</span>
                )}

                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone No."
                  value={formData.phone}
                  onChange={handleChange}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                />
                {errors.phone && (
                  <span style={{ color: "red" }}>{errors.phone}</span>
                )}

                <select
                  name="location"
                  value={formData.location}
                  onChange={handleLocationChange}
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "6px",
                  }}
                >
                  <option value="">Select a location</option>
                  <option value="Bali">Bali</option>
                  <option value="Georgia">Georgia</option>
                  <option value="India">India</option>
                  <option value="Goa">Goa</option>
                  <option value="Other">Other</option>
                </select>
                {formData.location === "Other" && (
                  <input
                    type="text"
                    name="customLocation"
                    placeholder="Enter custom location"
                    value={formData.customLocation}
                    onChange={handleChange}
                    style={{
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "6px",
                    }}
                  />
                )}
                {errors.location && (
                  <span style={{ color: "red" }}>{errors.location}</span>
                )}

                <ReCAPTCHA
                  sitekey="6LfG7hsrAAAAABrKlWfFUvwsE5GhzxM7YD6IfhYP"
                  onChange={handleCaptchaChange}
                />
                {errors.captcha && (
                  <span style={{ color: "red" }}>{errors.captcha}</span>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    background: "#0284c7",
                    color: "#fff",
                    padding: "12px",
                    border: "none",
                    borderRadius: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  {loading ? "Submitting..." : "Submit"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Where We Excel */}
      <section className="bg-[#0284c7]  text-white text-center py-12 px-6">
        <h1 className="text-2xl md:text-3xl font-bold mb-2">Where We Excel</h1>
        <p className="text-sm md:text-base">
          We specialize in the world’s most sought-after destinations:
        </p>

        {/* Destination Cards */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-8 max-w-6xl mx-auto">
          {destinations.map((dest, idx) => (
            <div
              key={idx}
              className="relative rounded-lg overflow-hidden shadow-lg group"
            >
              {/* Background Image */}
              <img
                src={dest.image}
                alt={dest.name}
                className="w-full h-40 md:h-56 object-cover transform group-hover:scale-110 transition duration-500"
              />

              {/* Overlay with text */}
              <div className="absolute inset-0 bg-black/40 group-hover:bg-black/60 transition duration-500 flex items-center justify-center">
                <h3 className="text-lg md:text-xl font-semibold">
                  {dest.name}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Holidays Designed */}
      <section className="bg-white text-center py-12 px-6">
        <h2 className="text-2xl md:text-3xl font-bold mb-10">
          Holidays Designed for You
        </h2>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {holidayPackages.map((pkg, idx) => (
            <div
              key={idx}
              className={`${pkg.bg} rounded-lg p-6 shadow hover:shadow-xl transition`}
            >
              <h3 className="font-bold mb-3">{pkg.title}</h3>

              {/* Image inside card */}
              <img
                src={pkg.image}
                alt={pkg.title}
                className="w-full h-40 object-cover rounded-lg mb-4"
              />

              <p className="text-sm md:text-base">{pkg.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Flexible Packages */}
      <section className="bg-white py-16 px-6 grid md:grid-cols-2 gap-8 items-center">
        {/* Left Image Section */}
        <div className="relative flex justify-center md:justify-center">
          {/* Main Top Image */}
          <div className="overflow-hidden rounded-t-full rounded-b-md border-4 border-green-500 w-64 md:w-80 h-96 shadow-lg">
            <img
              src="https://images.unsplash.com/photo-1529070538774-1843cb3265df"
              alt="Flight Wing"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Small Bottom Image */}
          <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-32 md:w-40 border-4 border-green-500 shadow-md">
            <img
              src="https://images.unsplash.com/photo-1534447677768-be436bb09401"
              alt="Airport"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        {/* Right Text Section */}
        <div>
          <h2 className="text-3xl font-bold mb-4">Flexible Packages</h2>
          <p className="mb-6 text-gray-700">
            We know every traveler is unique.
          </p>
          <p className="font-semibold mb-3">That’s why we offer:</p>
          <ul className="list-disc list-inside space-y-2 text-gray-800">
            <li>
              <strong>Inclusive of flights</strong>: When booking packages for
              groups or families
            </li>
            <li>
              <strong>Exclusive of flights</strong>: When booking individual
              trips with custom flexibility
            </li>
          </ul>
        </div>
      </section>

      {/* Get In Touch Button */}
      <div className="flex justify-center my-8" onClick={scrollToContact}>
        <button className="demo-btn">Get In Touch</button>
      </div>

      {/* Services */}
      <section className="bg-white py-16 px-6 text-center">
        {/* Heading */}
        <h2 className="text-3xl font-bold mb-2">Services That Set Us Apart</h2>
        <p className="text-gray-600 mb-4">
          Our promise goes beyond standard travel deals.
        </p>
        <p className="font-semibold mb-10">
          We curate journeys that blend comfort with authenticity
        </p>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          <div>
            <img
              src="/door.png"
              alt="Door-to-door packages"
              className="w-full h-56 object-cover rounded-lg shadow"
            />
            <p className="mt-3 font-medium">Door-to-door packages</p>
          </div>

          <div>
            <img
              src="/travel.png"
              alt="Luxury travel packages international"
              className="w-full h-56 object-cover rounded-lg shadow"
            />
            <p className="mt-3 font-medium">
              Luxury travel packages international
            </p>
          </div>

          <div>
            <img
              src="/food.png"
              alt="Indian food abroad"
              className="w-full h-56 object-cover rounded-lg shadow"
            />
            <p className="mt-3 font-medium">Indian food abroad</p>
          </div>
        </div>

        {/* Buttons */}
        {/* <div className="flex justify-between items-center mt-10 max-w-6xl mx-auto">
                    <button className="px-6 py-2 border border-green-500 text-green-600 rounded-full font-medium hover:bg-green-50 transition">
                        See All
                    </button>

                    <div className="flex gap-3">
                        <button className="w-10 h-10 flex items-center justify-center bg-green-500 text-white rounded-full shadow hover:bg-green-600 transition">
                            ←
                        </button>
                        <button className="w-10 h-10 flex items-center justify-center bg-green-500 text-white rounded-full shadow hover:bg-green-600 transition">
                            →
                        </button>
                    </div>
                </div> */}
      </section>

      {/* Why Choose Us */}
      <section className="bg-[#0284c7] text-white py-12 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Why Choose Us?</h1>
          <ul className="list-disc list-inside space-y-4">
            <li>
              9+ years of corporate travel expertise, now serving customers
              directly
            </li>
            <li>Specialists in luxury international holiday packages</li>
            <li>
              Your go-to partner for honeymoon packages from India and family
              vacation packages
            </li>
            <li>
              Personalized itineraries that combine comfort, culture, and class
            </li>
          </ul>
        </div>
      </section>

      {/* CTA */}
      <section className="relative bg-white py-16 px-6 overflow-hidden">
        {/* Background Decorations */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-green-300"></div>
        <div className="absolute top-0 right-0 w-10 h-10 border-t border-r border-blue-900"></div>
        <div className="absolute bottom-0 left-0 w-10 h-10 border-b border-l border-blue-900"></div>
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-green-300"></div>

        {/* Blue Content Box */}
        <div className="relative bg-[#0284c7] text-white text-center max-w-3xl mx-auto py-12 px-6 rounded-sm shadow-md z-10">
          <h1 className="text-2xl md:text-3xl font-bold mb-4">
            Start Your Journey Today
          </h1>
          <p className="mb-6 text-base md:text-lg">
            The world isn’t just to be seen, it’s to be experienced in style.
          </p>
          <p
            onClick={() => {
              const contactSection = document.getElementById("contact");
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: "smooth" });
              }
            }}
            className="cursor-pointer flex justify-center items-center gap-2 text-base md:text-lg font-bold text-white hover:underline"
          >
            <span className="text-pink-300 text-xl">📞</span>
            Call us today and let’s plan your next extraordinary journey.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Main;
